module.exports = "img/hide.057fe0e.png";